/**
 * Admin impersonation — client-side check.
 *
 * Reads the non-httpOnly indicator cookie synchronously.
 * Use in React components to guard write operations (register, save)
 * without waiting for an async API call.
 */

export function isImpersonating(): boolean {
  if (typeof document === 'undefined') return false
  return document.cookie.includes('crucible-impersonate-active=1')
}
